import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

export function useKnowledgeGroupAssignmentsQuery(databaseId: string) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && databaseId.length > 0;

  return useQuery({
    queryKey: knowledgeQueryKeys.groupAssignments(databaseId),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listGroupAssignments(databaseId),
  });
}
